// Third Party
import React from 'react';

// Components
import { Divider } from '../misc';

// Utils
import { FormattedMessage, formatMessage } from '../../../utils/i18n';
import { MARKUP_TOOLS } from '../../../utils/markup-tools';
import { Tooltip } from '@capintel/component-lib/tooltip';
import { Button } from '@capintel/component-lib/button';
import { IconName } from '@capintel/component-lib/icon';

type Props = {
  selectedMarkupTool?: string;
  toggleMarkupTool: (markupTool: string) => void;
  resetMarkup: () => void;
  hidden?: boolean;
};

const MarkupToolbar = ({ resetMarkup, selectedMarkupTool, toggleMarkupTool, hidden }: Props) => {
  const renderButton = (icon: IconName, markupTool: string, tooltipMessage?: string) => {
    const active = selectedMarkupTool === markupTool;

    return (
      <Tooltip content={tooltipMessage}>
        <Button variant={active ? 'primary' : 'secondary'} appearance="icon" icon={icon} onClick={() => toggleMarkupTool(markupTool)} />
      </Tooltip>
    );
  };

  return (
    <div className="markup-toolbar">
      {/* Render container to preserve height of toolbar in comparison page. CSS visilibity hidden was not used as it had a delay */}
      {!hidden && (
        <>
          <Button variant="secondary" onClick={resetMarkup}>
            <FormattedMessage id="MarkupTools.Reset" />
          </Button>

          <Divider />

          {renderButton('circle-outline', MARKUP_TOOLS.CIRCLE, formatMessage('MarkupTools.Circle'))}
          {renderButton('square', MARKUP_TOOLS.SQUARE, formatMessage('MarkupTools.Square'))}
          {renderButton('chat-bubble-outline', MARKUP_TOOLS.COMMENT, formatMessage('MarkupTools.Comment.Text'))}
          {renderButton('draw', MARKUP_TOOLS.HIGHLIGHT, formatMessage('MarkupTools.Highlight'))}
        </>
      )}
    </div>
  );
};

export default MarkupToolbar;
